import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CombatProvider } from './game/combat.jsx';
import CombatScreen from './game/CombatScreen.jsx';
import Room from './game/Room.jsx';

function App() {
  return (
    <BrowserRouter>
      <CombatProvider>
        <Routes>
          <Route path="/" element={<CombatScreen />} />
          <Route path="/lair/:id" element={<Room />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CombatProvider>
    </BrowserRouter>
  );
}

export default App;
